import { Commands } from '.';
var MsgBox = (function () {
    function MsgBox(data) {
        this.promptText = data.PromptText;
        this.inputRequest = data.InputRequest;
        this.caption = data.Caption;
        this.text = data.Text;
        this.buttons = data.Buttons;
        this.icons = data.Icons;
        this.continuationID = data.Continuation_UniqueID;
        this.parameters = data.MessageParameters;
        this.forceContinuation = data.ForceContinuation;
    }
    Object.defineProperty(MsgBox.prototype, "name", {
        get: function () {
            return Commands.MsgBox;
        },
        enumerable: false,
        configurable: true
    });
    return MsgBox;
}());
export { MsgBox };
